import React from 'react';
import { testimonials } from '../data/content';
export function Testimonials() {
  return <section className="w-full bg-white px-5 py-20 sm:py-28" data-id="element-200" data-mp="3kqnsmw4m036i">
      <div className="mx-auto max-w-4xl" data-id="element-201" data-mp="3ksgzocj4wpf1">
        <div className="text-center" data-id="element-202" data-mp="3fz5ndvvjzgfq">
          <span className="eyebrow-rule text-[11px] font-bold uppercase tracking-[0.22em] text-teal" data-id="element-203" data-mp="3fy30s059k05m">
            Recensioni verificate
          </span>
          <h2 className="mt-4 font-display text-[1.85rem] font-black leading-tight tracking-tight text-navy sm:text-[2.6rem]" data-id="element-204" data-mp="36yplgqugkhcz">
            Cosa dicono le tue{' '}
            <span className="italic text-grape" data-id="element-205" data-mp="321zauj1fadyy">colleghe</span>
          </h2>
        </div>

        <div className="mx-auto mt-10 grid max-w-3xl gap-5 sm:grid-cols-2" data-id="element-206" data-mp="2x11rw48l9fwe">
          {testimonials.map(item => <figure key={item.name} className="flex h-full flex-col rounded-2xl border border-navy/10 bg-cream p-6" data-id="element-207" data-mp="2s3t8k0bpf5tk">
              <div className="text-sm tracking-[0.2em] text-ochre" aria-label="5 stelle su 5" data-id="element-208" data-mp="v72ftgnn6uin">
                <span aria-hidden="true" data-id="element-209" data-mp="q8ixdq89c0v1">★ ★ ★ ★ ★</span>
              </div>
              <blockquote className="mt-4 flex-1 font-display text-sm italic leading-relaxed text-navy/85" data-id="element-210" data-mp="h4n2k87sbt9c">
                &laquo;{item.quote}&raquo;
              </blockquote>
              <figcaption className="mt-6" data-id="element-211" data-mp="7927ku14vt93">
                <p className="text-xs font-bold text-navy" data-id="element-212" data-mp="7a4uyrz8zdk9">{item.name}</p>
                <p className="text-xs text-navy/45" data-id="element-213" data-mp="c73rtiaapym5">{item.role}</p>
              </figcaption>
            </figure>)}
        </div>
      </div>
    </section>;
}